module.exports = __webpack_public_path__ + "static/media/jobs_example.da287d64.csv";